import { useStore } from "@/store";
import { flashWarning } from "@/utils";

export const fetchDiagnoskoder = async ({ query }: { query?: string; is_valid_now?: boolean } = {}) => {
    const store = useStore();

    try {
        const params: { q?: string; is_valid_now?: boolean } = {};

        if (query) {
            params.q = query;
        }
        params.is_valid_now = true;

        const { subsetName } = await store.dispatch("diagnoskod/fetchDiagnoskoder", {
            filterParams: params,
            displayMode: true,
        });

        return store.getters["diagnoskod/diagnoskodSubset"]({ subsetName, displayMode: true });
    } catch (error) {
        console.log(error);
        flashWarning("Kunde inte hämta diagnoskoder");
    }
};
